import React from 'react';

const LOGO_URL = 'https://customer-assets.emergentagent.com/job_cricket-dev-portal/artifacts/51imfhjx_cricket-namibia-logo.png';

export default function Header({ summary }) {
  return (
    <header className="header" data-testid="header">
      <div className="header-left">
        <img src={LOGO_URL} alt="Cricket Namibia" className="header-logo" data-testid="header-logo" />
        <div>
          <div className="header-title" data-testid="header-title">
            ICC Census Data
          </div>
          <div className="header-subtitle">Namibia &middot; 2025</div>
        </div>
      </div>
      <div className="header-right">
        <span className="header-badge" data-testid="badge-regions">14 Regions</span>
        <span className="header-badge accent" data-testid="badge-year">2025</span>
      </div>
    </header>
  );
}
